import { axiosBasic, axiosBearer } from "../config/axios-common";
import ProfessionalAttachment from "../models/ProfessionalAttachment";

const updateProfessionalAttachmentClinicalStaff = (data: FormData, professionalId: string) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }
  return axiosBasic.post(`/sam/v1/professionalattachment/clinicalstaff/upload?professionalId=${encodeURIComponent(professionalId)}`, data, config);
};

const updateProfessionalAttachmentMultiprofissional = (data: FormData, professionalId: string) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }
  return axiosBasic.post(`/sam/v1/professionalattachment/multiprofessional/upload?professionalId=${encodeURIComponent(professionalId)}`, data, config);
};

const updateProfessionalAttachmentSpecialAuthorization = (data: FormData, professionalId: string) => {

  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  };

  return axiosBasic.post(`/sam/v1/professionalattachment/specialauthorization/upload?professionalId=${encodeURIComponent(professionalId)}`, data, config);
}

const updateProfessionalAttachmentMedicoParceiro = (data: FormData, professionalId: string) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }

  return axiosBasic.post(`/sam/v1/professionalattachment/partnerdoctor/upload?professionalId=${encodeURIComponent(professionalId)}`, data, config);
};

const updateProfessionalAttachmentAssistantDoctor = (data: FormData, professionalId: string) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }

  return axiosBasic.post(`/sam/v1/professionalattachment/assistantdoctor/upload?professionalId=${encodeURIComponent(professionalId)}`, data, config);
};


const updateProfessionalAttachmentReRegistration = (data: FormData, professionalId: string) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }

  return axiosBasic.post(`/sam/v1/professionalattachment/reRegistration/upload?professionalId=${encodeURIComponent(professionalId)}`, data, config);
};

const updateProfessionalAttachmentMedicalServiceProvider = (data: FormData, professionalId: string) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }
  return axiosBasic.post(`/sam/v1/professionalattachment/medicalserviceprovider/upload?professionalId=${encodeURIComponent(professionalId)}`, data, config);
};

const deleteAttachment = (professionalAttachmentId: string) => {

  const config = {
    headers: {
      'Content-Type': 'application/json',
    }
  }
  return axiosBasic.post(`/sam/v1/professionalattachment/delete?professionalAttachmentId=${encodeURIComponent(professionalAttachmentId)}`, config);
};


const CreateAndGetProfessionalAttachmentFromTasy = async (requestId: string): Promise<ProfessionalAttachment[]> => {

  const response = await axiosBearer.post(`/sam/v1/professionalattachment/CreateAndGetAttachmentFromTasy?requestId=${encodeURIComponent(requestId)}`, {}).then(response => {

    var result = new Array<ProfessionalAttachment>();

    if (response.data !== undefined && response.data.length > 0) {

      result = response.data.map((row: any) => {
        let item = ProfessionalAttachment.NewInstance();

        item.Id = row.id;
        item.DeliveryDate = row.deliveryDateFormatted;
        item.AttachmentTypeTasyId = row.attachmentTypeTasyId;
        item.DescriptionTasy = row.descriptionTasy;
        item.Description = row.description;
        item.TasyCode = row.tasyCode;
        item.RemoveTasy = row.removeTasy;
        item.Expired = row.expired;

        return item;
      });
    }

    return result;
  })

  const responseData = await response;

  return responseData;

};

const GetProfessionalAttachmentPending = async (requestId: string): Promise<ProfessionalAttachment[]> => {

  const response = await axiosBearer.get(`/sam/v1/professionalattachment/ProfessionalAttachmentPending?requestId=${encodeURIComponent(requestId)}`).then(response => {

    var result = new Array<ProfessionalAttachment>();

    if (response.data !== undefined && response.data.length > 0) {

      result = response.data.map((row: any) => {
        let item = ProfessionalAttachment.NewInstance();

        item.Id = row.id;
        item.DeliveryDate = row.deliveryDateFormatted;
        item.AttachmentTypeTasyId = row.attachmentTypeTasyId;
        item.AttachmentTypeId = row.attachmentTypeId;
        item.DescriptionTasy = row.descriptionTasy;
        item.FileName = row.fileName;
        item.EncriptId = row.encriptId;
        item.Description = row.description;
        item.TasyCode = row.tasyCode;
        item.RemoveTasy = row.removeTasy;
        item.Mandatory = row.mandatory;

        return item;
      });
    }

    return result;
  })

  const responseData = await response;

  return responseData;

};


const exportedObject = {
  updateProfessionalAttachmentClinicalStaff,
  updateProfessionalAttachmentMultiprofissional,
  updateProfessionalAttachmentSpecialAuthorization,
  updateProfessionalAttachmentMedicoParceiro,
  updateProfessionalAttachmentAssistantDoctor,
  updateProfessionalAttachmentReRegistration,
  updateProfessionalAttachmentMedicalServiceProvider,
  deleteAttachment,
  CreateAndGetProfessionalAttachmentFromTasy,
  GetProfessionalAttachmentPending
};


export default exportedObject
